<template>
  <div>
   <video controls :width="width" :height="srcData[id].realHeight">
    <source :src="srcData[id].link" type="video/mp4">
  </video>
  </div>
</template>
<script>
export default {
  name: "video",
  data() {
    return {
      id: this.$route.query.id || 0,
      srcData:[
        {link: 'https://oss.kiscloud.net/wechat/images/20231123/liti.mp4', width:1920,height:1080,realHeight:''},
        {link: 'https://oss.kiscloud.net/wechat/images/20231123/longxiaobao.mp4', width:720,height:480,realHeight:''},
        {link: 'https://oss.kiscloud.net/wechat/images/20231123/motianlun.mp4', width:720,height:480,realHeight:''},
        {link: 'https://oss.kiscloud.net/wechat/images/20231123/xuanzhuan.mp4', width:720,height:480,realHeight:''},
      ],
      width:''
    };
  },
  mounted(){
    this.width = window.innerWidth
    this.srcData = this.srcData.map(item => {
      item.realHeight = this.width*item.height/item.width
      return item
    })
  }
};
</script>